import React, { FC } from 'react'
import { Well } from '@wmgtech/legato'
import { TemplateForm } from 'modules/Labels/components'
import { getTemplateTitle } from 'modules/Labels/utils'
import { InfoFormProps } from './InfoForm.props'
import './InfoForm.scss'

const InfoForm: FC<InfoFormProps> = ({ setTemplateValues, templates }) => {
  return (
    <form className="template-form form-container">
      <div className="sbx-row sbx-row-gutter-24 info-form">
        <div className="sbx-col-xs-24 sbx-col-xs-order-1 sbx-col-md-12 sbx-col-md-order-1 sbx-col-lg-15 sbx-col-lg-order-0">
          {templates
            .filter((template) => template.template_type !== 'story_guide')
            .map((template) => (
              <div key={template.id} className="info-form__block">
                <h2 className="info-form__title">
                  {getTemplateTitle(template.template_type)}
                </h2>
                <TemplateForm
                  key={template.template_type}
                  setTemplateValues={setTemplateValues}
                  template={template}
                />
              </div>
            ))}
        </div>
        <div className="sbx-col-xs-24 sbx-col-xs-order-1 sbx-col-md-12 sbx-col-md-order-1 sbx-col-lg-9 sbx-col-lg-order-0">
          <Well
            className="info-form__well"
            containerStyle="solid"
            header="Let's get started customizing your project for Storybox"
          >
            <p>
              As a Label Admin, you can edit your label's Local Team Information and Local Project Information templates
              to suite your specific needs. This gives Project Owners a framework to populate the relevant project
              information quickly.
            </p>
          </Well>
        </div>
      </div>
    </form>
  )
}

export default InfoForm
